import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import VueTimepicker from "vue2-timepicker";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AutomationTime",
  components: {
    VueTimepicker
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: String,
      required: true
    },
    formatType: {
      type: String,
      default: "minutes"
    },
    hideClearButton: {
      type: Boolean,
      default: true
    },
    dropDirection: {
      validator: prop => {
        var _context;
        return _includesInstanceProperty(_context = ["down", "up", "auto"]).call(_context, prop);
      },
      default: "down"
    },
    id: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value ? moment(this.value, this.formatToShow["24h"]).format(this.formatToShow["12h"]) : moment(this.defaultValue, this.formatToShow["24h"]).format(this.formatToShow["12h"]);
      },
      set(value) {
        if (value !== this.value) this.$emit("input", value);
      }
    },
    format() {
      return {
        minutes: {
          "12h": "hh:mm A",
          "24h": "HH:mm"
        },
        seconds: {
          "12h": "hh:mm:ss A",
          "24h": "HH:mm:ss"
        }
      };
    },
    formatToShow() {
      return this.format[this.formatType];
    }
  },
  methods: {
    handleChange(event) {
      const {
        HH,
        mm,
        ss
      } = event.data;
      this.localValue = `${HH}:${mm}:${ss || `00`}`;
    }
  }
});